import { render, staticRenderFns } from "./niqList.vue?vue&type=template&id=d41e6930&scoped=true&"
import script from "./niqList.vue?vue&type=script&lang=js&"
export * from "./niqList.vue?vue&type=script&lang=js&"
import style0 from "./niqList.vue?vue&type=style&index=0&id=d41e6930&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d41e6930",
  null
  
)

export default component.exports